/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const fileUploadSectionStyle = {
  section: {
    marginBottom: "3rem",
  },
  file: {
    fontWeight: 400,
    textAlign: "right",
    padding: "0.5rem 0",
  },
  icon: {
    verticalAlign: "text-bottom",
    margin: "0 0.5rem",
  },
  deleteIcon: {
    verticalAlign: "text-bottom",
    margin: "0 0.5rem",
    cursor: "pointer",
  },
  addMoreContainer: {
    textAlign: "right",
  },
  addMoreButton: (theme: Theme) => ({
    color: "primary.main",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  }),
  notificationModal: {
    margin: "1rem 0",
  },
};

export default fileUploadSectionStyle;
